import { useQuery } from '@tanstack/react-query'
import { getPlansService } from '@/services/subscriptions'

export const usePlans = () =>
  useQuery({
    queryKey: ['plans'],
    queryFn: getPlansService,
  })
